import {stringUnion} from '@utils';

export interface Filter {
    searchString: string,
    sources: SourceType[],
    from: number,
    size: number
}

export const SourceType = stringUnion('community', 'documentation', 'partner_documentation', 'knowledge_base', 'release_notes', 'drafts');
// eslint-disable-next-line
export type SourceType = typeof SourceType.type;

export const emptyFilter: Filter = {
    searchString: '',
    sources: SourceType.values,
    from: 0,
    size: 10
};
